import customCheckboxRadioSwitchStyles from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch';
import { Field, FieldProps, useFormikContext } from 'formik';
import React from 'react';
import { ECampaignDeliveryAddressTarget } from 'types/campaign';

import { FormControlLabel, Radio } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import { enumToReadableName } from 'utils/lib';

const useStyles = makeStyles((theme) => ({
  ...customCheckboxRadioSwitchStyles(theme),
  root: {
    '& a': {
      color: theme.palette.orange.main,
      textDecoration: 'underline',
    },
    '& label': {
      marginRight: '40px',
    },
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.darkGray.main,
  },
  subTitle: {
    fontSize: '14px',
    color: theme.palette.gray.main,
    fontWeight: 500,
    margin: '6px 0 10px',
  },
}));

const ChooseDeliveryAddressTarget = () => {
  const classes = useStyles();
  const { setFieldValue } = useFormikContext();

  return (
    <Field name="deliveryAddressTarget">
      {({ field }: FieldProps) => (
        <div className={classes.root}>
          <h4 className={classes.title}>
            Delivery Address Target
          </h4>
          <h5 className={classes.subTitle}>
            Choose whether this campaign sends postcards and letters to the owner’s mailing address or the property’s site address. Useful for seasonal markets—e.g., snowbird areas where absentee owners only occupy the site address during winter months.
          </h5>
          {Object.values(ECampaignDeliveryAddressTarget).map((type) => (
            <FormControlLabel
              key={type}
              control={(
                <Radio
                  {...field}
                  checked={field.value === type}
                  onChange={() => setFieldValue(field.name, type, true)}
                  icon={(
                    <FiberManualRecordIcon
                      className={classes.radioUnchecked}
                    />
                  )}
                  checkedIcon={(
                    <FiberManualRecordIcon
                      className={classes.radioChecked}
                    />
                  )}
                  classes={{
                    checked: classes.radio,
                    root: classes.radioRoot,
                  }}
                />
              )}
              classes={{
                label: classes.label,
                root: classes.labelRoot,
              }}
              label={enumToReadableName(type)}
            />
          ))}
        </div>
      )}
    </Field>
  );
};

export default ChooseDeliveryAddressTarget;
